/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ContentValue = zod.object({
  booleanValue: zod.boolean().nullish(),
  dateValue: zod.string().nullish(),
  datetimeValue: zod.string().nullish(),
  jsonValue: zod.unknown().optional(),
  numericValue: zod.number().nullish(),
  stringValue: zod.string().nullish(),
});

export type ContentValue = zod.input<typeof ContentValue>;
export type ContentValueOutput = zod.output<typeof ContentValue>;
